/** Нормализация поля children из ответа API (legacy: childrens) */
export function getApiTreeChildren<T>(item: { children?: T[]; childrens?: T[] }): T[] {
  const nodes = item.children ?? item.childrens
  return Array.isArray(nodes) ? nodes : []
}
